import { DropdownItem } from "../types";

export const mapLabelsToIds = (
  labels: string[] = [],
  dropdownOptions: DropdownItem<number>[] = [],
): number[] => {
  if (labels.length === 0 || dropdownOptions.length === 0) {
    return [];
  }

  return labels
    .map((label) => {
      const matchingOption = dropdownOptions.find(
        (option) => option.label === label,
      );

      const value = matchingOption ? matchingOption?.value : label;

      const numericValue = Number(value);
      return !isNaN(numericValue) ? numericValue : null;
    })
    .filter((value): value is number => value !== null);
};
